import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const SideMenuItemDefaultBox = styled.li<{hidden?: boolean}>`
    display: ${({hidden}) => hidden ? "none" : "block"};
    margin: 0 1rem;
    border-top: none;
    border-bottom: 1px solid ${({theme}) => theme.colors.boxBorderDark};;

    &:last-child {
        border-bottom: none;
    }
`;

const SideMenuItemCasino777Box = styled(SideMenuItemDefaultBox)`
    margin: 0.4rem 1rem;
    border: none;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 1rem 1rem;
    }
    &:first-child {
        border-top: none;
    }
`;

export const SideMenuItemBox = styledByTheme(SideMenuItemDefaultBox).forCasino777(SideMenuItemCasino777Box).apply();
